/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { defaultPersonData } from '../../utils/store';

const form4Slice = createSlice({
  name: 'form4',
  initialState: {
    data: {
      personType: '',
      ...defaultPersonData,
    },
    state: {},
    municipality: {},
  },
  reducers: {
    setFormData(state, { payload }) {
      state.data = payload;
    },
    setStateAndMunicipality(state, { payload }) {
      state.state = payload.state;
      state.municipality = payload.municipality;
    },
  },
});

export const form4Actions = form4Slice.actions;

export default form4Slice;
/* eslint-enable no-param-reassign */
